const ATTACHMENT_CLICK_SELECTOR = [
  ".attachment-preview-container",
  ".attachment-item",
  ".attachments-viewer",
  ".attachments-block",
  ".preview-modal",
].join(", ");

/**
 * Определяет клик по вложению, который не должен открывать строку таблицы
 */
export function isAttachmentClickTarget(target) {
  return Boolean(target?.closest?.(ATTACHMENT_CLICK_SELECTOR));
}
